var OverviewTabMixin = {
    props: {
        overviewhash: {
            type: String,
            required: true
        },
        more: {
            type: Object,
            required: false,
            default: () => {return {}}
        }
    },

    created: function () {
        // this.fetch()
    },  

    methods: {
        // fetch(){
        //     // ajax method with linkedid / linkedtype / tab

        //     // return an array of items
        //     console.log('fetch mixin');
        //     // this.items = [];
        // }
    },

    computed: {
        linkedtype(){
            return this.$store.getters.linkedtype
        },
        linkedid(){
            return this.$store.getters.linkedid
        },
    }
}


export default OverviewTabMixin;
